import type { IconSvgObject } from './types';

const Scooter04Icon: IconSvgObject = [
  ["circle", { cx: "4", cy: "18", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "20", cy: "18", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6.51383 18.0002L15 18C15 15.2386 17.2386 13 20 13L17.9069 5.46471C17.6664 4.59907 16.8782 4 15.9798 4H15M16 15L4 16.0002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Scooter04Icon;
